
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.375 3.583a.792.792 0 00-.792.792v14.25c0 .437.355.792.792.792h9.5a.792.792 0 00.792-.792v-9.5H14.5a2.375 2.375 0 01-2.375-2.375V3.583h-4.75zm6.333 1.12l2.84 2.839H14.5a.792.792 0 01-.792-.792V4.703zM5 4.375A2.375 2.375 0 017.375 2h5.542a.79.79 0 01.56.232l5.541 5.542a.79.79 0 01.232.56v10.291A2.375 2.375 0 0116.875 21h-9.5A2.375 2.375 0 015 18.625V4.375zm3.958 8.708c0-.437.355-.791.792-.791h2.375a.792.792 0 010 1.583H9.75a.792.792 0 01-.792-.792zm0 3.167c0-.437.355-.792.792-.792h4.75a.792.792 0 010 1.584H9.75a.792.792 0 01-.792-.792z"}})])
          )
        }
      }
    